export const colorOptions = [
    {value: '#34B689', label: 'green'},
    {value: '#FABF48', label: 'orange'},
    {value: '#F92C84', label: 'fucsia'},
    {value: '#009FE3', label: 'blue'}
]